import React from 'react';
import { observer } from 'mobx-react';

import { ROUTES } from 'shared/constants';
import { UiIcon, UiNavLink } from 'shared/uikit-new';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationTaskTrackerTaskExpiredAtProposeAccepted = observer(function VmNotificationTaskTrackerTaskExpiredAtProposeAccepted(
    {
        notification,
        onClose = () => undefined,
        onDelete = () => undefined,
    }: PropsType,
) {

    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}><UiIcon.CircleX size={16} color="#ffffff" fill="#22c55e" /><span>Крайний срок изменен</span></div>
            <div className="vm-notification__description">
                <span>Постановщик подтвердил изменение крайнего срока задачи </span>
                <UiNavLink to={ROUTES.TASK_TRACKER_TASK(notification.data.task.id)} onClick={onClose}>[№{notification.data.task.id}] {notification.data.task.name}</UiNavLink>
            </div>
            <div className="vm-notification__additional">
                {!!notification.data.task.expiredAtProposeIsAcceptedComment && (
                    <div>
                        <label style={{ width: 95 }}>Комментарий:</label>
                        <span>{notification.data.task.expiredAtProposeIsAcceptedComment}</span>
                    </div>
                )}
            </div>
        </div>
    );
});
